import type { UserOrigins } from '../../lib/types';

export interface IPageFrameState {
  loading: boolean;
  errorShow: boolean;
  successShow: boolean;
  msg: string;
  settings?: ISettings;
  settingsFetched: boolean;
  showAlert?: boolean;
  message?: string;
  alert?: IAlert;
  recipientColorCounter?: number;
  fetchedUserSubscription?: boolean;
  isFetchingUserInfo?: boolean;
  isUserInfoFetched?: boolean;
  fetchedGlobalToken?: boolean;
}

export interface IAlert {
  message: string;
  type: 'ERROR' | 'SUCCESS' | 'WARNING';
  visible: boolean;
}

export interface ISettings {
  account: IAccountSettings;
  user: IUserSettings;
}

export interface IAccountSettings {
  template?: ITemplateSettings;
  envelope?: IEnvelopeSettings;
  userOrigin?: UserOrigins;
}

export type AutoStampDateTimePreference = 'Date' | 'DateTime' | 'None' | undefined;
export interface IUserSettings {
  autoStampDateTime?: {
    preference?: AutoStampDateTimePreference;
  };
  keepBlocksSelected?: boolean;
  emailDocsAsAttachment?: boolean;
  subscription?: IUserSubscription;
  trial?: Trial;
  dateFormat?: IDateFormat;
  memberships?: IUserMemberships;
  automatedReminders?: {
    enabled: boolean;
    updatedDate?: string;
  };
}
export interface IDateFormat {
  preference: DateFormatType;
  selectionModalViewed?: boolean;
}

export enum DateFormatType {
  Default = 'MM/DD/YYYY',
  DayMonthYear = 'DD/MM/YYYY',
  YearMonthDay = 'YYYY/MM/DD',
}

export interface IUserSubscription {
  type: string;
  created: string;
  validUntil: string;
  subscriptionId: string;
  customerId: string;
  status: string;
  productPriceId: string;
  email: string;
  price: number;
  discount?: number;
  /** ISO string date */
  currentPeriodEnd: string;
  /** ISO string date */
  currentPeriodStart: string;
  cancelAtPeriodEnd?: boolean;
  cancelAt?: string;
}

export type Trial = {
  startDate: string;
  endDate: string;
  extensions?: TrialExtension[];
  status?: 'Active' | 'Inactive';
};

export type TrialExtension = {
  startDate: Date;
  endDate: Date | null;
  envelopesLeft: number;
};

export interface ITemplateSettings {
  tagging?: ITaggingSettings;
  blockTypes?: ISettingsBlockTypes;
  recipientTitles?: string[];
}

export interface IEnvelopeSettings {
  blockTypes?: ISettingsBlockTypes;
}

export interface ISettingsBlockTypes {
  disabled: string[];
}

export interface ITaggingSettings {
  enabled: boolean;
  tagTypes: ITagType[];
}

export interface ITagType {
  id: string;
  name: string;
  displayType: 'AUTOCOMPLETE' | 'DROPDOWN';
  options: string[];
  iconName?: string;
  placeholderText?: string;
  helperText?: string;
}

export interface IUserMemberships {
  id: string;
  subscriptions: SubscriptionSource[];
  permissions: string[];
}

export interface SubscriptionSource {
  id: string;
  name: string;
  source: string;
  permissions: string[];
}

export enum PermissionType {
  DS3 = 'ds3.*',
  FORMS = 'forms.*',
}

export type ProductPriceInfo = {
  productName: string;
  productId: string;
  price: PriceInfo | null;
};

export type PriceInfo = {
  priceId: string;
  price: string;
  description: string;
  unitAmount: number;
};
